

















































import Vue from "vue";
import Ajax from "@/lib/ajax";
import util from "@/lib/util";
export default Vue.extend({
  data() {
    return {
      userInfo: "",
      formValidate: {
        oldPwd: "",
        newPwd: "",
        newPwd2: ""
      },
      ruleValidate: {
        oldPwd: [
          {
            required: true,
            message: "旧密码不能为空",
            trigger: "blur"
          }
        ],
        newPwd: [
          {
            required: true,
            message: "新密码不能为空",
            trigger: "blur"
          }
        ],
        newPwd2: [
          {
            required: true,
            message: "确认密码不能为空",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    // this.getCurrentUserProfileForEdit();
  },
  methods: {
    getCurrentUserProfileForEdit() {
      Ajax.get(
        "/api/services/app/Profile/GetCurrentUserProfileForEdit",
        {}
      ).then(res => {
        let result = res.data.result;
        this.userInfo = result;
      });
    },

    handleSubmit(name) {
      let that = this;
      (this.$refs[name] as any).validate(valid => {
        if (valid) {
          // this.$Message.success("Success!");
          if (this.formValidate.newPwd !== this.formValidate.newPwd2) {
            this.$Message.error("新密码和确认密码不一致！");
          } else {
            console.log(this.formValidate);
            Ajax.post("/api/identity/my-profile/change-password", {
              currentPassword: this.formValidate.oldPwd,
              newPassword: this.formValidate.newPwd
            }).then(res => {
              // if (res.data.success) {
                this.$Message.success("修改成功，请重新登录！");
                setTimeout(function() {
                  that.$store.commit("app/logout", that);
                  util.abp.auth.clearToken();
                  location.reload();
                }, 800);
              // }
            });
          }
        }
      });
    }
  }
});
